$(document).ready(function() {
    var ulElement = $("#aa");
    var secondLiElement = ulElement.find("span:eq(0)");
    var secondLiContent = secondLiElement.text();
    var yj_price = Number(secondLiContent.substring(1));   
    
    var okba = $("#flag").text();
    var okbb = Number(okba);
    
    var cj_price = 0 ;
    var save_price = 0 ;

    if(yj_price>=109 && yj_price<199){ 
      cj_price = (yj_price*0.8).toFixed(2);  // 20% OFF
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="LOVE20"; 
    }else if(yj_price>=199){
      cj_price = (yj_price*0.75).toFixed(2);  // 25% OFF
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="LOVE25";  
    }else{ 
      cj_price =  yj_price.toFixed(2);
      save_price = 0;
      saleCode =" "; 
    }


    if(okbb==0){
      var fq_price = (yj_price/4).toFixed(2);
      $("#aa").removeClass("yc_price");
      $("#bb").removeClass("show_price");
      $("#aa").addClass("show_price");
      $("#bb").addClass("yc_price");
    }else{
      var fq_price = (cj_price/4).toFixed(2);
      $("#aa").removeClass("show_price");
      $("#bb").removeClass("yc_price");
      $("#bb").addClass("show_price");
      $("#aa").addClass("yc_price");  
    }

    if(saleCode=="LOVE20"){
      var yhed = "20%";
      var overmn = "$109";

      $("#yc1").addClass("ycang");
      $("#yc2").removeClass("ycang");
      $("#yc3").removeClass("ycang");
      $("#yc4").removeClass("ycang");

    }else if(saleCode=="LOVE25"){
      var yhed = "25%";
      var overmn = "$199";

      $("#yc2").addClass("ycang");
      $("#yc1").removeClass("ycang");
      $("#yc3").removeClass("ycang");
      $("#yc4").removeClass("ycang");

    }else{
      var yhed = "0";
      var overmn = ""; 
    }
  
    $("#savePrice").text("$"+save_price);
    console.log(cj_price);
    $("#bb").text("$"+cj_price);
    $("#windows_bb").text("$"+cj_price);
    $("#win_yj_price").text("$"+yj_price);
    $("#win_savePrice").text("$"+save_price);
    $("#ww").text("$"+cj_price);
    $("#sale_code").text(saleCode);
    $("#win_saleCode").text(saleCode);
    $("#price_fq").text("$"+fq_price);
    $("#yhed").text(yhed);
    $("#overmn").text(overmn);
  });